import { render, staticRenderFns } from "./create-declare-customs.vue?vue&type=template&id=5100ccc4&scoped=true"
import script from "./create-declare-customs.vue?vue&type=script&lang=ts"
export * from "./create-declare-customs.vue?vue&type=script&lang=ts"
import style0 from "./create-declare-customs.vue?vue&type=style&index=0&id=5100ccc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5100ccc4",
  null
  
)

export default component.exports